module.exports = __webpack_public_path__ + "img/clock-waiting.9c969136.svg";